const getCanUseDocumentOptions = (documents, types) =>
  documents.filter(d => types.indexOf(d.document_type) > -1 && !d.not_use)
    .map(fd => ({ label: fd.document_name, value: fd.id }));

export default getCanUseDocumentOptions;



// WEBPACK FOOTER //
// ./client/app/utils/documents.js